import React from "react";
import { TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import { useStyles } from "./EnhancedTableHead.styles";
import { IEnhancedTableHead } from "./EnhancedTableHeadInterfaces";
import { IMainTableColumn } from "../../MainTableInterfaces";

const EmptyComponent = () => <></>;
const StyledUnfoldMoreIcon = () => <UnfoldMoreIcon />;

export const EnhancedTableHead = ({
    order,
    orderBy,
    onRequestSort,
    headCells,
    headerAlign,
    tableCellCustomStyle,
}: IEnhancedTableHead) => {
    const classes = useStyles();
    const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
        onRequestSort(event, property);
    };
    return (
        <TableHead>
            <TableRow>
                {headCells.map(({ id, label, icon, hideSortIcon, headerCustomStyles }: IMainTableColumn) => (
                    <TableCell
                        key={id}
                        align={headerAlign}
                        sortDirection={orderBy === id ? order : false}
                        classes={{
                            root: classes.root,
                        }}
                        style={headerCustomStyles}
                        className={headerCustomStyles ? undefined : tableCellCustomStyle}
                    >
                        <TableSortLabel
                            hideSortIcon={hideSortIcon}
                            active={orderBy === id}
                            direction={orderBy === id ? order : "asc"}
                            onClick={!hideSortIcon ? createSortHandler(id) : undefined}
                            IconComponent={!hideSortIcon ? StyledUnfoldMoreIcon : EmptyComponent}
                        >
                            {icon ? icon() : label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};
